// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {470: "a7cdf36db4",866: "270d184bc7",}[chunkId] + ".css"
}